import { Entity } from '@toggle/toggle';
import { isToday } from 'date-fns';
import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from '~/views/explore/components/explore-table/ExploreTable.styles';

import { ScenarioIconWrapper } from '~/views/dashboard/my-assets-widget/assets-table/insights-cell/insights-icon/InsightIcon.styles';
import { InsightsWithDirection } from '../../explore-table-utils/explore-table-utils';
import { InsightIconsRoot } from '~/views/insights/components/insight-icons-root/InsightIconsRoot';
import { InsightsTooltip } from '~/views/insights/components/insights-tooltip/InsightsTooltip';
import { Count } from '../truncate-single-icons/count/Count';

const HORIZONTAL_CHART_COMBINE_SIZE = { width: '42px', height: '28px' };
export const HORIZONTAL_TABLE_COMBINE_SIZE = { width: '36px', height: '20px' };

export interface TruncateCombinedIconsProps {
  displayedInsights: InsightsWithDirection[][];
  entity?: Entity;
  shouldTruncate: boolean;
  insightsCount?: number;
  handleSelect?: (insightId: string, entity: Entity) => void;
  variant?: 'chart' | 'assets-table';
}

export const TruncateCombinedIcons = ({
  displayedInsights,
  insightsCount = 0,
  entity,
  shouldTruncate,
  handleSelect,
  variant = 'chart',
}: TruncateCombinedIconsProps) => {
  const { t } = useTranslation(['insights']);
  const size =
    variant === 'chart'
      ? HORIZONTAL_CHART_COMBINE_SIZE
      : HORIZONTAL_TABLE_COMBINE_SIZE;
  return (
    <S.InsightsWrapper>
      {displayedInsights.map((combine, index) => {
        if (!combine.length) {
          return null;
        }

        const {
          createdAt,
          direction,
          matched,
          horizon,
          episodesCount,
          median,
          stars,
          name,
          insightId,
        } = combine[0];

        const episodeLabel = t('insights:insightCard.episode', {
          count: episodesCount,
        });
        const iconIsRead = combine[0].read;

        return (
          <S.InsightsWrapper key={`${direction}-${index}`}>
            <InsightsTooltip
              key={`${direction}-${index}`}
              conditions={combine}
              direction={direction}
              customSize={size}
              isStarred={isToday(new Date(createdAt))}
              isCombined
              isRead={iconIsRead}
              layout="horizontal"
              horizon={horizon}
              episodeLabel={episodeLabel}
              median={median}
              stars={stars}
              name={name}
              entityTag={entity?.tag}
            >
              <ScenarioIconWrapper $isRead={!!iconIsRead}>
                <InsightIconsRoot
                  conditions={combine}
                  direction={direction}
                  customSize={size}
                  isStarred={isToday(new Date(createdAt))}
                  isMatched={matched}
                  isCombined
                  layout="horizontal"
                  onIconClick={(e: SyntheticEvent) => {
                    e.stopPropagation();
                    handleSelect && entity
                      ? handleSelect(insightId, entity)
                      : null;
                  }}
                />
              </ScenarioIconWrapper>
            </InsightsTooltip>
          </S.InsightsWrapper>
        );
      })}
      {shouldTruncate && (
        <Count count={insightsCount - displayedInsights.length} />
      )}
    </S.InsightsWrapper>
  );
};
